import { createFileRoute } from '@tanstack/react-router'
import ConfirmEmail from 'features/Auth/ConfirmEmail/ConfirmEmail.component'

export const Route = createFileRoute('/(auth)/_auth/confirm-email')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ConfirmEmail />
}
